/** Final overlay pack: story comments/write, tabs, local, community, chat — merged in screenUiTranslations */

export const STORY_UI = {
  ko: {
    write: '글쓰기',
    commentsTitle: '댓글 {count}개',
    commentsEmptyCount: '댓글 0개',
    commentsEmptyHint: '첫 댓글을 남겨보세요!',
    commentPlaceholder: '댓글 추가...',
    commentPost: '게시',
    anonymous: '익명',
  },
  en: {
    write: 'Write',
    commentsTitle: '{count} comments',
    commentsEmptyCount: '0 comments',
    commentsEmptyHint: 'Be the first to comment!',
    commentPlaceholder: 'Add a comment…',
    commentPost: 'Post',
    anonymous: 'Anonymous',
  },
  vi: {
    write: 'Viết',
    commentsTitle: '{count} bình luận',
    commentsEmptyCount: '0 bình luận',
    commentsEmptyHint: 'Hãy là người bình luận đầu tiên!',
    commentPlaceholder: 'Thêm bình luận…',
    commentPost: 'Đăng',
    anonymous: 'Ẩn danh',
  },
  ru: {
    write: 'Написать',
    commentsTitle: '{count} комментариев',
    commentsEmptyCount: '0 комментариев',
    commentsEmptyHint: 'Оставьте первый комментарий!',
    commentPlaceholder: 'Добавить комментарий…',
    commentPost: 'Отправить',
    anonymous: 'Аноним',
  },
  ja: {
    write: '書く',
    commentsTitle: 'コメント {count}件',
    commentsEmptyCount: 'コメント0件',
    commentsEmptyHint: '最初のコメントを残しましょう！',
    commentPlaceholder: 'コメントを追加…',
    commentPost: '投稿',
    anonymous: '匿名',
  },
  'zh-CN': {
    write: '写作',
    commentsTitle: '{count} 条评论',
    commentsEmptyCount: '0 条评论',
    commentsEmptyHint: '来发表第一条评论吧！',
    commentPlaceholder: '添加评论…',
    commentPost: '发布',
    anonymous: '匿名',
  },
  'zh-TW': {
    write: '寫作',
    commentsTitle: '{count} 則留言',
    commentsEmptyCount: '0 則留言',
    commentsEmptyHint: '來發表第一則留言吧！',
    commentPlaceholder: '新增留言…',
    commentPost: '發佈',
    anonymous: '匿名',
  },
  th: {
    write: 'เขียน',
    commentsTitle: '{count} ความคิดเห็น',
    commentsEmptyCount: '0 ความคิดเห็น',
    commentsEmptyHint: 'แสดงความคิดเห็นแรกเลย!',
    commentPlaceholder: 'เพิ่มความคิดเห็น…',
    commentPost: 'โพสต์',
    anonymous: 'ไม่ระบุชื่อ',
  },
  id: {
    write: 'Tulis',
    commentsTitle: '{count} komentar',
    commentsEmptyCount: '0 komentar',
    commentsEmptyHint: 'Jadilah yang pertama berkomentar!',
    commentPlaceholder: 'Tambah komentar…',
    commentPost: 'Kirim',
    anonymous: 'Anonim',
  },
  hi: {
    write: 'लिखें',
    commentsTitle: '{count} टिप्पणियाँ',
    commentsEmptyCount: '0 टिप्पणियाँ',
    commentsEmptyHint: 'पहली टिप्पणी लिखें!',
    commentPlaceholder: 'टिप्पणी जोड़ें…',
    commentPost: 'पोस्ट',
    anonymous: 'अज्ञात',
  },
};

const mk = (o) => o;

export const FINAL_UI = {
  th: mk({
    shorts: {
      discover: 'ค้นพบ',
      storyHome: 'หน้า Story',
      storyTabNearby: '📍 ใกล้ฉัน',
      storyTabWebtoon: '🎨 เว็บตูน',
      storyTabPopular: '⭐ ยอดนิยม',
    },
    local: {
      emergencySection: '🆘 ฉุกเฉินและความปลอดภัย',
      emergency: 'ติดต่อฉุกเฉิน',
      lostFound: 'ของหาย',
      expiry: 'แจ้งเตือนหมดอายุ',
      expatInfoTitle: 'คู่มือชาวต่างชาติ',
    },
    life: { favoritesSection: 'รายการโปรด' },
    serviceV2: {
      secTrade: '🛍️ ซื้อขายและช้อปปิ้ง',
      items: { used: 'ตลาดมือสอง', vehicles: 'รถมือสอง', groupBuy: 'ซื้อร่วม', currencyExchange: 'แลกเงิน' },
    },
    community: {
      sortNew: 'ล่าสุด',
      sortHot: 'ยอดนิยม',
      writeFab: 'โพสต์ใหม่',
      categories: {
        near: 'พื้นที่ของฉัน',
        all: 'ทั้งหมด',
        question: 'ถามตอบ',
        info: 'เคล็ดลับ',
        meet: 'นัดพบ',
        general: 'ทั่วไป',
        lost: 'ของหาย',
        free: 'อิสระ',
        emergency: 'ฉุกเฉิน',
        education: 'การศึกษา',
      },
    },
    common: { report: 'รายงาน' },
    chat: {
      title: 'แชท',
      newChat: '+ แชทใหม่',
      emptyTitle: 'ยังไม่มีแชท',
      emptyDesc: 'เริ่มคุยกับชาวต่างชาติ',
      promoTitle: 'ลองบริการเหล่านี้',
      promoInvite: 'ชวนเพื่อน',
      promoTheme: 'ธีม',
      promoThemeDesc: 'ปรับธีมแชท',
    },
  }),
  ja: mk({
    shorts: {
      discover: '発見',
      storyHome: 'ストーリーホーム',
      storyTabNearby: '📍 近く',
      storyTabWebtoon: '🎨 ウェブトーン',
      storyTabPopular: '⭐ 人気',
    },
    local: {
      emergencySection: '🆘 緊急・安全',
      emergency: '緊急連絡先',
      lostFound: '遺失物',
      expiry: '期限リマインダー',
      expatInfoTitle: '外国人必須ガイド',
    },
    life: { favoritesSection: 'お気に入り' },
    serviceV2: {
      secTrade: '🛍️ 取引・ショッピング',
      items: { used: '中古マーケット', vehicles: '中古車', groupBuy: '共同購入', currencyExchange: '両替' },
    },
    community: {
      sortNew: '最新',
      sortHot: '人気',
      writeFab: '新規投稿',
      categories: {
        near: 'マイエリア',
        all: 'すべて',
        question: 'Q&A',
        info: 'ヒント',
        meet: 'ミートアップ',
        general: '一般',
        lost: '紛失',
        free: '自由',
        emergency: '緊急',
        education: '教育',
      },
    },
    common: { report: '報告' },
    chat: {
      title: 'チャット',
      newChat: '+ 新規チャット',
      emptyTitle: 'チャットはまだありません',
      emptyDesc: '仲間と会話を始めましょう',
      promoTitle: 'こんなサービスは？',
      promoInvite: '友達を招待',
      promoTheme: '外観',
      promoThemeDesc: 'チャットテーマ',
    },
  }),
  'zh-CN': mk({
    shorts: {
      discover: '发现',
      storyHome: '故事首页',
      storyTabNearby: '📍 附近',
      storyTabWebtoon: '🎨 网漫',
      storyTabPopular: '⭐ 热门',
    },
    local: {
      emergencySection: '🆘 紧急与安全',
      emergency: '紧急联系',
      lostFound: '失物招领',
      expiry: '到期提醒',
      expatInfoTitle: '外籍必备指南',
    },
    life: { favoritesSection: '收藏' },
    serviceV2: {
      secTrade: '🛍️ 交易与购物',
      items: { used: '二手市场', vehicles: '二手车', groupBuy: '团购', currencyExchange: '换汇' },
    },
    community: {
      sortNew: '最新',
      sortHot: '热门',
      writeFab: '发帖',
      categories: {
        near: '我的地区',
        all: '全部',
        question: '问答',
        info: '贴士',
        meet: '聚会',
        general: '综合',
        lost: '失物',
        free: '自由',
        emergency: '紧急',
        education: '教育',
      },
    },
    common: { report: '举报' },
    chat: {
      title: '聊天',
      newChat: '+ 新聊天',
      emptyTitle: '还没有聊天',
      emptyDesc: '和外籍朋友开始对话',
      promoTitle: '试试这些服务',
      promoInvite: '邀请好友',
      promoTheme: '外观',
      promoThemeDesc: '自定义聊天主题',
    },
  }),
  'zh-TW': mk({
    shorts: {
      discover: '發現',
      storyHome: '故事首頁',
      storyTabNearby: '📍 附近',
      storyTabWebtoon: '🎨 網漫',
      storyTabPopular: '⭐ 熱門',
    },
    local: {
      emergencySection: '🆘 緊急與安全',
      emergency: '緊急聯絡',
      lostFound: '失物招領',
      expiry: '到期提醒',
      expatInfoTitle: '外籍必備指南',
    },
    life: { favoritesSection: '收藏' },
    serviceV2: {
      secTrade: '🛍️ 交易與購物',
      items: { used: '二手市場', vehicles: '二手車', groupBuy: '團購', currencyExchange: '換匯' },
    },
    community: {
      sortNew: '最新',
      sortHot: '熱門',
      writeFab: '發文',
      categories: {
        near: '我的地區',
        all: '全部',
        question: '問答',
        info: '貼士',
        meet: '聚會',
        general: '綜合',
        lost: '失物',
        free: '自由',
        emergency: '緊急',
        education: '教育',
      },
    },
    common: { report: '檢舉' },
    chat: {
      title: '聊天',
      newChat: '+ 新聊天',
      emptyTitle: '還沒有聊天',
      emptyDesc: '和外籍朋友開始對話',
      promoTitle: '試試這些服務',
      promoInvite: '邀請好友',
      promoTheme: '外觀',
      promoThemeDesc: '自訂聊天主題',
    },
  }),
  vi: mk({
    shorts: {
      discover: 'Khám phá',
      storyHome: 'Trang truyện',
      storyTabNearby: '📍 Gần tôi',
      storyTabWebtoon: '🎨 Webtoon',
      storyTabPopular: '⭐ Phổ biến',
    },
    local: {
      emergencySection: '🆘 Khẩn cấp & An toàn',
      emergency: 'Liên hệ khẩn cấp',
      lostFound: 'Đồ thất lạc',
      expiry: 'Nhắc hạn dùng',
      expatInfoTitle: 'Cẩm nang thiết yếu',
    },
    life: { favoritesSection: 'Yêu thích' },
    serviceV2: {
      secTrade: '🛍️ Mua bán & Mua sắm',
      items: { used: 'Chợ đồ cũ', vehicles: 'Xe cũ', groupBuy: 'Mua chung', currencyExchange: 'Đổi tiền' },
    },
    community: {
      sortNew: 'Mới nhất',
      sortHot: 'Phổ biến',
      writeFab: 'Bài mới',
      categories: {
        near: 'Khu vực của tôi',
        all: 'Tất cả',
        question: 'Hỏi đáp',
        info: 'Mẹo',
        meet: 'Gặp gỡ',
        general: 'Chung',
        lost: 'Thất lạc',
        free: 'Tự do',
        food: 'Ẩm thực',
        humor: 'Hài hước',
        realestate: 'Bất động sản',
        jobs: 'Việc làm',
        emergency: 'Khẩn cấp',
        education: 'Giáo dục',
      },
    },
    common: { report: 'Báo cáo' },
    chat: {
      title: 'Trò chuyện',
      newChat: '+ Chat mới',
      emptyTitle: 'Chưa có cuộc trò chuyện',
      emptyDesc: 'Bắt đầu trò chuyện với cộng đồng expat',
      promoTitle: 'Khám phá dịch vụ',
      promoInvite: 'Mời bạn bè',
      promoTheme: 'Giao diện',
      promoThemeDesc: 'Tùy chỉnh giao diện chat',
    },
  }),
  ru: mk({
    shorts: {
      discover: 'Обзор',
      storyHome: 'Лента',
      storyTabNearby: '📍 Рядом',
      storyTabWebtoon: '🎨 Вебтун',
      storyTabPopular: '⭐ Популярное',
    },
    local: {
      emergencySection: '🆘 Экстренно и безопасность',
      emergency: 'Экстренные контакты',
      lostFound: 'Потерянные вещи',
      expiry: 'Напоминание о сроке',
      expatInfoTitle: 'Гид для экспатов',
    },
    life: { favoritesSection: 'Избранное' },
    serviceV2: {
      secTrade: '🛍️ Торговля и покупки',
      items: { used: 'Барахолка', vehicles: 'Авто', groupBuy: 'Совместная покупка', currencyExchange: 'Обмен валют' },
    },
    community: {
      sortNew: 'Новые',
      sortHot: 'Популярные',
      writeFab: 'Новый пост',
      categories: {
        near: 'Мой район',
        all: 'Все',
        question: 'Вопросы',
        info: 'Советы',
        meet: 'Встречи',
        general: 'Общее',
        lost: 'Потеряно',
        free: 'Свободно',
        food: 'Еда',
        humor: 'Юмор',
        realestate: 'Недвижимость',
        jobs: 'Работа',
        emergency: 'Срочно',
        education: 'Образование',
      },
    },
    common: { report: 'Жалоба' },
    chat: {
      title: 'Чаты',
      newChat: '+ Новый чат',
      emptyTitle: 'Чатов пока нет',
      emptyDesc: 'Начните общение с экспатами',
      promoTitle: 'Попробуйте сервисы',
      promoInvite: 'Пригласить друзей',
      promoTheme: 'Оформление',
      promoThemeDesc: 'Тема чата',
    },
  }),
  id: mk({
    shorts: {
      discover: 'Jelajahi',
      storyHome: 'Beranda Story',
      storyTabNearby: '📍 Dekat saya',
      storyTabWebtoon: '🎨 Webtoon',
      storyTabPopular: '⭐ Populer',
    },
    local: {
      emergencySection: '🆘 Darurat & Keamanan',
      emergency: 'Kontak darurat',
      lostFound: 'Barang hilang',
      expiry: 'Pengingat kedaluwarsa',
      expatInfoTitle: 'Panduan ekspat',
    },
    life: { favoritesSection: 'Favorit' },
    serviceV2: {
      secTrade: '🛍️ Jual-beli & Belanja',
      items: { used: 'Pasar bekas', vehicles: 'Mobil bekas', groupBuy: 'Beli bersama', currencyExchange: 'Kurs' },
    },
    community: {
      sortNew: 'Terbaru',
      sortHot: 'Populer',
      writeFab: 'Posting baru',
      categories: {
        near: 'Wilayah saya',
        all: 'Semua',
        question: 'Tanya jawab',
        info: 'Tips',
        meet: 'Bertemu',
        general: 'Umum',
        lost: 'Hilang',
        free: 'Bebas',
        emergency: 'Darurat',
        education: 'Pendidikan',
      },
    },
    common: { report: 'Laporkan' },
    chat: {
      title: 'Obrolan',
      newChat: '+ Obrolan baru',
      emptyTitle: 'Belum ada obrolan',
      emptyDesc: 'Mulai percakapan dengan sesama ekspat',
      promoTitle: 'Jelajahi layanan',
      promoInvite: 'Undang teman',
      promoTheme: 'Tampilan',
      promoThemeDesc: 'Sesuaikan tema obrolan',
    },
  }),
  hi: mk({
    shorts: {
      discover: 'खोजें',
      storyHome: 'स्टोरी होम',
      storyTabNearby: '📍 पास में',
      storyTabWebtoon: '🎨 वेबटून',
      storyTabPopular: '⭐ लोकप्रिय',
    },
    local: {
      emergencySection: '🆘 आपातकाल और सुरक्षा',
      emergency: 'आपात संपर्क',
      lostFound: 'खोया-पाया',
      expiry: 'समाप्ति अनुस्मारक',
      expatInfoTitle: 'एक्सपैट गाइड',
    },
    life: { favoritesSection: 'पसंदीदा' },
    serviceV2: {
      secTrade: '🛍️ व्यापार और खरीदारी',
      items: { used: 'पुराना बाज़ार', vehicles: 'पुरानी गाड़ी', groupBuy: 'सामूहिक खरीद', currencyExchange: 'विनिमय' },
    },
    community: {
      sortNew: 'नवीनतम',
      sortHot: 'लोकप्रिय',
      writeFab: 'नई पोस्ट',
      categories: {
        near: 'मेरा क्षेत्र',
        all: 'सभी',
        question: 'प्रश्न',
        info: 'टिप्स',
        meet: 'मिलन',
        general: 'सामान्य',
        lost: 'खोया',
        free: 'मुक्त',
        emergency: 'आपात',
        education: 'शिक्षा',
      },
    },
    common: { report: 'रिपोर्ट' },
    chat: {
      title: 'चैट',
      newChat: '+ नई चैट',
      emptyTitle: 'अभी कोई चैट नहीं',
      emptyDesc: 'साथी एक्सपैट से बात शुरू करें',
      promoTitle: 'ये सेवाएँ देखें',
      promoInvite: 'मित्र आमंत्रित करें',
      promoTheme: 'दिखावट',
      promoThemeDesc: 'चैट थीम बदलें',
    },
  }),
};
